import { dxPopupAnimation } from 'devextreme/ui/popup';

export enum DialogResult {
  None,
  Ok,
  Cancel,
  Abort,
  Retry,
  Ignore,
  Yes,
  No,
  Close,
}

export enum AbcPopupDialogButtonCombination {
  Ok,
  OkCancel,
  AbortRetryIgnore,
  YesNoCancel,
  YesIgnoreCancel,
  YesNo,
  RetryCancel,
  CopyOk,
  CopyClose,
  Custom,
}

export enum AbcPopupDialogButton {
  Ok,
  Cancel,
  Abort,
  Retry,
  Ignore,
  Yes,
  No,
  Copy,
}

export enum AbcPopupDialogTitleResourceIdentifier {
  Info = 'dialogTitle-info',
  Question = 'dialogTitle-question',
  Warning = 'dialogTitle-warning',
  Error = 'dialogTitle-error',
}

export enum AbcPopupDialogIconResourceIdentifier {
  Info = 'info-image',
  Question = 'question-image',
  Warning = 'warning-image',
  Error = 'error-image',
}

export enum AbcPopupDialogButtonResourceIdentifier {
  Ok = 'buttonText-ok',
  Cancel = 'buttonText-cancel',
  Abort = 'buttonText-abort',
  Retry = 'buttonText-retry',
  Ignore = 'buttonText-ignore',
  Yes = 'buttonText-yes',
  No = 'buttonText-no',
  Copy = 'buttonText-copy',
  Close = 'buttonText-close',
}

export enum AbcPopupDialogButtonClass {
  None = 'abc-popup-dialog-button-none',
  Ok = 'abc-popup-dialog-button-ok',
  Cancel = 'abc-popup-dialog-button-cancel',
  Abort = 'abc-popup-dialog-button-abort',
  Retry = 'abc-popup-dialog-button-retry',
  Ignore = 'abc-popup-dialog-button-ignore',
  Yes = 'abc-popup-dialog-button-yes',
  No = 'abc-popup-dialog-button-no',
  Copy = 'abc-popup-dialog-button-copy',
  Close = 'abc-popup-dialog-button-close',
}

export class AbcPopupDialogSettings {
  public buttonCombination: AbcPopupDialogButtonCombination;
  public customButtons: AbcPopupDialogCustomAction[] = [];

  public classExtension: string;

  public showTitle: boolean;
  public showCloseButton: boolean;
  public title: string;

  public showHeader: boolean;
  public headerTitle: string;
  public headerSVGIcon: string;

  public showContent: boolean;
  public htmlMessage: string;
  public shortMessage: string;
  public longMessage: string;

  public width: string | number;
  public maxWidth: string | number;
  public minWidth: string | number;
  public height: string | number;
  public maxHeight: string | number;
  public minHeight: string | number;
  public resizeEnabled: boolean;

  public hideOnOutsideClick: boolean;
  public shading: boolean;
  public shadingColor: string;
  public container: HTMLElement;
  public position: object;
  public animation: dxPopupAnimation;

  constructor() {
    this.showHeader = true;
    this.showContent = true;

    this.height = 'auto';
    this.width = 500;

    this.hideOnOutsideClick = false;
    this.shading = true;
  }
}

export class AbcPopupDialogCustomAction {
  public text: string;
  public dialogResult: DialogResult;
  public cssClass: string;
  public elementAttr: object;

  constructor() {
    //
  }
}
